import React, { useState } from "react";
import FormatedDate from "./FormatedDate";
import Icon from "./Icon";
import TempUnits from "./TempUnits";

export default function CurrentWeatherInfo(props) {
  return (
    <div className="CurrentWeatherInfo">
      <div className="row">
        <div className="col-1"></div>
        <div className="col">
          <h2>{props.data.city}</h2>
          <div className="discription text-capitalize">
            {props.data.description}
          </div>
        </div>
        <div className="col">
          <div className="daytime">
            <FormatedDate date={props.data.date} />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-1"></div>
        <div className="col">
          <div className="clearfix">
            <div className="float-left">
              <Icon code={props.data.icon} />
            </div>
            <div className="float-left">
              <TempUnits celsius={props.data.temperature} />
            </div>
          </div>
        </div>

        <div className="col">
          <ul>
            <li>Humidity: {props.data.humidity}%</li>
            <li>Wind: {props.data.wind}km/h</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
